<template>
  <v-container fill-height>
    <v-layout justify-center align-center>
      <v-flex xs12 sm10>
        <v-card class="mb-4 elevation-10 pa-1" flat>
          <!-- <v-card-title>
          </v-card-title> -->
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap justify-center align-center>
                <v-flex xs12>     
                   <span class="headline font-weight-bold green--text darken-2">HELLO</span>
                   <span class="headline font-weight-thin yellow--text darken-2">WORLD!!</span>
                </v-flex>
                <v-flex xs12 md4
                 align-center
                 justify-center
                >
                <v-container grid-list-md>
                  <v-layout row wrap justify-center align-center>
                    <v-flex class="text-xs-center" xs12>
                      <v-avatar size="210" class="green lighten-2 ma-1">
                        <img src="/mypix.jpeg" class="pa-1" alt="My Display Picture">
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12>
                      <div v-html="my_objective" class="font-italic font-weight-bold text-xs-center black green--text pa-2">
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
                </v-flex>
                <v-flex
                  xs12
                  md8
                  align-center
                  justify-center
                  layout
                >
                  <MyDetails />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>Follow Links goes here</v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import MyDetails from '../components/MyDetails'

  export default {
    components: {
      MyDetails
    },
    props: {
      source: String
    },
    data: () => ({
      my_objective: 
      "<p>Yo!, I am a very Easy going <b>SOFTWARE DEVELOPER</b> and a good <b>TEAM PLAYER</b>.\
        <br/ > I am highly organized with good <b>PEOPLE MANAGEMENT SKILLS</b> and <b> over 3 years </b> of progressive development and Improvement in this field. </p> \
        <p> I can definitely bring great team management skills to the table. <br /> One more thing, I kind of like to be challenged to learn New Stuffs and I can some how quickly learn any tool needed to get the job done.</p>",
    }),
  }
</script>
